import React, { useState } from "react";
import "../App.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar">
      {/* LEFT SECTION: LOGO + BRAND NAME */}
      <div className="navbar-left">
        <img src="/logo.jpg" alt="Logo" className="nav-logo" />
        <h2 className="brand-name">kk-realtors.in</h2>
      </div>

      <div className="menu-btn" onClick={() => setOpen(!open)}>
        {open ? "✖" : "☰"}
      </div>

      <ul className={open ? "nav-links active" : "nav-links"}>
        <li><a href="#home" onClick={() => setOpen(false)}>Home</a></li>
        <li><a href="#about" onClick={() => setOpen(false)}>About</a></li>
        <li><a href="#whyus" onClick={() => setOpen(false)}>Why Us</a></li>
        <li><a href="#services" onClick={() => setOpen(false)}>Services</a></li>
        <li><a href="#contact" className="contact-btn" onClick={() => setOpen(false)}>Contact</a></li>
      </ul>
    </nav>
  );
}
